import { BUTTON_SIZE } from "./defaults";

import AlignCenter from "../../icons/AlignCenter";
import AlignRight from "../../icons/AlignRight";
import AlignLeft from "../../icons/AlignLeft";
import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";

export const BUTTON_STYLE = {
  OUTLINE: "outline",
  FILL: "fill",
};

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 32 },
];

export const SIZE_OPTIONS = [
  { label: "S", value: BUTTON_SIZE.SMALL },
  { label: "M", value: BUTTON_SIZE.MEDIUM },
  { label: "L", value: BUTTON_SIZE.LARGE },
];

export const STYLE_OPTIONS = [
  { label: "Outline", value: BUTTON_STYLE.OUTLINE, i18n: "outline" },
  { label: "Fill", value: BUTTON_STYLE.FILL, i18n: "fill"},
];

export const INTERACTION_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const ICON_POSITION_OPTIONS = [
  { label: "Left", i18n: "left", value: "left" },
  { label: "Right", i18n: "right", value: "right" },
];
